import React from "react";
import { tone, ymd } from "./typeColors";

const startOfCalendar = (d) => {
  const first = new Date(d.getFullYear(), d.getMonth(), 1);
  first.setDate(first.getDate() - first.getDay());
  return first;
};

export default function MonthView({ date, appts, onOpen, onJumpDay, onCreate }) {
  const start = startOfCalendar(date);
  const cells = Array.from({ length: 42 }, (_, i) => {
    const x = new Date(start); x.setDate(x.getDate() + i); return x;
  });
  const currentMonth = date.getMonth();
  const todayKey = ymd(new Date());
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  return (
    <div data-testid="cal-month-view">
      <div className="grid grid-cols-7 mb-1.5">
        {dayNames.map((n) => (
          <div key={n} className="text-[10px] font-semibold uppercase tracking-wider text-slate-400 text-center py-2">{n}</div>
        ))}
      </div>
      <div className="grid grid-cols-7 gap-1.5">
        {cells.map((d) => {
          const key = ymd(d);
          const isCurrent = d.getMonth() === currentMonth;
          const isToday = key === todayKey;
          const day = appts.filter((a) => a.date === key).sort((a, b) => a.time.localeCompare(b.time));
          return (
            <div
              key={key}
              data-testid={`cal-month-cell-${key}`}
              className={`min-h-[100px] rounded-xl border p-1.5 flex flex-col gap-1 transition-colors
                ${isCurrent ? "bg-white/60 dark:bg-slate-900/40 border-slate-200/70 dark:border-white/10" : "bg-slate-50/60 dark:bg-slate-900/20 border-transparent"}`}
            >
              <button
                onClick={() => onJumpDay(d)}
                className={`self-start text-[11px] font-semibold rounded-full h-6 min-w-6 px-1.5 flex items-center justify-center
                  ${isToday ? "brand-gradient text-white shadow" : isCurrent ? "text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800" : "text-slate-400"}`}
              >
                {d.getDate()}
              </button>
              <div className="flex flex-col gap-0.5 overflow-hidden">
                {day.slice(0, 3).map((a) => {
                  const t = tone(a.type);
                  return (
                    <button
                      key={a.id}
                      data-testid={`cal-month-appt-${a.id}`}
                      onClick={(e) => { e.stopPropagation(); onOpen(a); }}
                      className={`text-left text-[10px] leading-tight rounded-md px-1.5 py-1 border ${t.soft} truncate flex items-center gap-1`}
                      title={`${a.time} · ${a.title}`}
                    >
                      <span className={`inline-block h-1.5 w-1.5 rounded-full ${t.bg} shrink-0`} />
                      <span className="font-mono">{a.time}</span>
                      <span className="truncate font-semibold">{a.title}</span>
                    </button>
                  );
                })}
                {day.length > 3 && (
                  <button data-testid={`cal-month-more-${key}`} onClick={() => onJumpDay(d)} className="text-[10px] text-indigo-600 dark:text-indigo-300 font-semibold text-left px-1">
                    +{day.length - 3} more
                  </button>
                )}
                {day.length === 0 && isCurrent && (
                  <button data-testid={`cal-month-add-${key}`} onClick={() => onCreate({ date: key, time: "09:00" })} className="text-[10px] text-slate-400 hover:text-indigo-600 text-left px-1 opacity-0 hover:opacity-100 transition-opacity">
                    + Add
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
